/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request schema for sending an audio message in a conversation via the
 * /chat/{conversation_id}/voice endpoint
 *
 * Note: This is used for form field validation. The actual audio file
 * is handled separately as UploadFile in the endpoint.
 */
export interface AudioMessageRequest {
  initial_agent?: string | null;
  contexts?: string | null;
  audio_file: Blob;
}
